import { render, staticRenderFns } from "./SidebarNavigation.vue?vue&type=template&id=19d8287e&scoped=true&"
import script from "./SidebarNavigation.vue?vue&type=script&lang=js&"
export * from "./SidebarNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d8287e",
  null
  
)

export default component.exports